import type { i18n } from 'i18next';

export type TFrontendLogProvider = (...args: any[]) => void;

export type TDateTimeDefaults = {
  timezone: string;
  timezoneUTCOffset: number;
  locale: string | undefined;
  timeFormatWithSeconds: string;
  timeFormat: string;
  is24Hour: boolean;
  dayMonthYearFormat: string;
  naturalLongDateFormat: string;
  naturalShortDayMonthYearFormat: string;
  naturalShortDayMonthFormat: string;
};

export type TFrontendRuntimeContext = {
  store: any | null;
  i18n: i18n;
  dateTime: TDateTimeDefaults;
  log: TFrontendLogProvider;
  error: TFrontendLogProvider;
  assetResolver?: {
    setAssets(assetsBaseUri: string, assets: any): void;
    resolve(path: string): string;
    relativePath(path: string, scaleOptions?: any): string;
  };
};

let resolveServerContext: (() => TFrontendRuntimeContext | undefined) | undefined;

export function setServerFrontendRuntimeContextResolver(resolver: () => TFrontendRuntimeContext | undefined): void {
  resolveServerContext = resolver;
}

export function getFrontendRuntimeContext(): TFrontendRuntimeContext | undefined {
  return resolveServerContext?.();
}
